import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

import {
  BidActivity,
  BlockStatus,
  ControlsContainer,
  HighBidContainer,
  ItemDetailsContainer,
  ItemName,
  ItemNumberContainer,
  LaneStatus,
  MediaContainer,
  PopoutComments,
  SellerActions,
  SideNavContainer,
  TopBarContainer,
} from 'components/project/AuctioneerScreen';

import { Layout } from './Styles';

const NPALayoutAuctioneer2 = () => {
  const {
    AuctionStore: {
      auctionID,
      auctionLaneId,
      auctionLaneName,
      auctionList,
      connected,
      getAuctionAndLaneTitle,
      laneList,
      laneMetrics,
      runListStats,
    },
    UIStore: { handleJoinAuction, handleJoinLane },
    BidStore: { auction: { auctioneerOpenPrivateNotes, auctioneerOpenPublicComments, auctBAFontSize } },
    MessageStore: { systemMessage, auctionLogObject },
  } = useStores();

  return (
    <Layout openPopoutComment={auctioneerOpenPublicComments.show || auctioneerOpenPrivateNotes.show}>
      <TopBarContainer
        connected={connected}
        title={getAuctionAndLaneTitle}
        laneName={auctionLaneName}
        showLogo
        showLaunchPad
        showLogout={false}
      />
      <SideNavContainer
        auctionList={auctionList}
        currentAuctionId={auctionList && auctionID}
        laneList={laneList}
        currentLaneId={laneList && auctionLaneId}
        handleAuctionChange={(e) => handleJoinAuction(e.target.value)}
        handleLaneChange={(e) => handleJoinLane(e.target.value)}
        totalUnitsRemaining={runListStats && runListStats["0"]}
        totalClientsInLane={laneMetrics && laneMetrics.totalClients - laneMetrics.totalClientsViewOnly}
      />
      <LaneStatus />
      <ItemNumberContainer />
      <BlockStatus key={systemMessage} screen="Auctioneer" />
      <ItemName />
      <SellerActions />
      <BidActivity key={`${auctionLogObject.length}_${auctBAFontSize}`} />
      <HighBidContainer />
      {!auctioneerOpenPublicComments.show && !auctioneerOpenPrivateNotes.show && <MediaContainer />}
      {(auctioneerOpenPublicComments.show || auctioneerOpenPrivateNotes.show) && <PopoutComments />}
      <ItemDetailsContainer />
      <ControlsContainer />
    </Layout>
  );
};

export default observer(NPALayoutAuctioneer2);
